<nz-upload
  nzType="drag"
  [nzMultiple]="multiple()"
  [nzAccept]="accept()"
  [nzDisabled]="disabled()"
  [nzBeforeUpload]="beforeUpload"
>
  <p class="ant-upload-drag-icon">
    <span nz-icon nzType="inbox"></span>
  </p>
  <p class="upload-title">{{ title() }}</p>
  <p class="upload-subtitle">{{ subtitle() }}</p>
</nz-upload>
